<script lang="ts" setup>
import { SancareOcticon } from '@sancare/typescript-commons'
import { computed, ref } from 'vue'

import { useStore } from '@/store'
import { ModeEnum, PmsiTypeEnum } from '@/store/modules/settings/types'
import { Stay, StayStatusEnum } from '@/store/modules/stay/types'

const store = useStore()

export interface StayReviewatorProps {
  stay: Stay
}

const props = defineProps<StayReviewatorProps>()

const isFetching = ref(false)

const updateStayStatusRequest = computed(() => store.state.stayDisplayer.updateStayStatusRequest)
const isStayReviewed = computed(() => props.stay.status === StayStatusEnum.REVIEW)
const buttonLabel = computed(() => isStayReviewed.value ? 'Retirer le statut "À revoir"' : 'Ajouter le statut "À revoir"')
const pmsiType = computed<PmsiTypeEnum>(() => store.state.settings.pmsi.pmsiType)
const mode = computed<ModeEnum>(() => store.state.settings.pmsi.mode)

async function reviewStay(cancelReview: boolean) {
  if (updateStayStatusRequest.value.fetching) {
    return
  }
  isFetching.value = true
  await store.dispatch(
    pmsiType.value === PmsiTypeEnum.MCO ? 'updateStayStatus' : 'smrStay/updateStayStatus',
    {
      stayId: props.stay.id,
      status: cancelReview ? 'unvalidated' : 'review',
      mode:  mode.value,
      pmsiType: pmsiType.value,
    }
  )
  isFetching.value = false
}
</script>

<template>
  <div>
    <div
      id="reviewator-button"
      v-tooltip.bottom="buttonLabel"
      :class="{
        loading: isFetching,
        active: isStayReviewed,
      }"
      class="btn btn-icon__action"
      @click=" reviewStay(isStayReviewed)"
    >
      <sancare-octicon
        v-if="!isFetching"
        :name="isStayReviewed ? 'bookmark-fill' : 'bookmark'"
        :width="16"
        :height="16"
      />
      <div
        v-else
        class="loader loader-xs loader-purple"
        :class="{ 'loader-grey': isStayReviewed }"
      />
    </div>
  </div>
</template>
